import React, { useState } from "react";

const faqs = [
  {
    question: "Do you serve breakfast ?",
    answer: (
      <>
        <p className="mb-2">
          Start your day light and fresh with our complimentary continental
          breakfast buffet, available weekdays from [Starting Time] to [Ending
          Time] and weekends from [Starting Time] to [Ending Time]. Enjoy a
          selection of continental staples like:
        </p>
        <ul className="ml-6 list-disc">
          <li>Freshly brewed coffee, tea, and hot chocolate</li>
          <li>A variety of juices and milk</li>
          <li>Pastries, muffins, and bagels</li>
          <li>Cereals and yogurt</li>
          <li>Fresh fruits and seasonal offerings</li>
        </ul>
      </>
    ),
  },
  {
    question: "What is your cancellation policy?",
    answer:
      "You may cancel your reservation free of charge up to 24 hours before check-in. After that, charges may apply.",
  },
  {
    question: "What time is check-in and check-out?",
    answer: "Check-in is from 2:00 PM, and check-out is by 11:00 AM.",
  },
  {
    question: "What types of payment do you accept?",
    answer:
      "We accept all major credit/debit cards, UPI, online banking, and cash payments at the front desk.",
  },
  {
    question: "What safety measures are in place at your hotel?",
    answer:
      "We follow all local safety protocols including regular sanitization, contactless check-in, and trained staff.",
  },
  {
    question:
      "Are there any accessibility features available for guests with disabilities?",
    answer:
      "Yes, our hotel offers wheelchair access, accessible bathrooms, and ramps at key locations.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(); // default first open

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="mx-auto mt-8 max-w-screen-2xl rounded-3xl bg-white p-4 shadow-md sm:p-8">
      <h2 className="mb-6 text-2xl font-bold">Frequently asked questions</h2>

      {faqs.map((faq, i) => (
        <div key={i} className="mb-6">
          <button
            type="button"
            onClick={() => toggleIndex(i)}
            className="flex w-full cursor-pointer items-center justify-between text-left focus:outline-none"
            aria-expanded={openIndex === i}
            aria-controls={`faq-${i}`}
            id={`faq-header-${i}`}
          >
            <span className="text-lg font-medium">{faq.question}</span>
            <svg
              className={`h-6 w-6 transition-transform duration-300 ${
                openIndex === i ? "rotate-180" : "rotate-0"
              }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          <div
            id={`faq-${i}`}
            role="region"
            aria-labelledby={`faq-header-${i}`}
            className={`transition-max-height mt-2 overflow-hidden duration-500 ease-in-out ${
              openIndex === i ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="text-gray-700">
              {typeof faq.answer === "string" ? (
                <p>{faq.answer}</p>
              ) : (
                faq.answer
              )}
            </div>
          </div>

          {i !== faqs.length - 1 && <hr className="mt-6 border-gray-300" />}
        </div>
      ))}
    </div>
  );
};

export default Faq;
